import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSolutionBetSizes = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#a)",
		children: [
			/* @__PURE__ */ _jsx("g", {
				clipPath: "url(#b)",
				children: /* @__PURE__ */ _jsx("path", {
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					d: "M6.7 10.7c0 .7-1.2 1.3-2.7 1.3-1.5 0-2.8-.6-2.8-1.3m5.5 0c0-.8-1.2-1.4-2.7-1.4-1.5 0-2.8.6-2.8 1.4m5.5 0v3.7c0 .7-1.2 1.4-2.7 1.4-1.5 0-2.8-.7-2.8-1.4v-3.7m5.5 0v1.2m-5.5-1.2v1.2m5.5 0v1.3c0 .7-1.2 1.3-2.7 1.3-1.5 0-2.8-.6-2.8-1.3v-1.3m5.5 0c0 .8-1.2 1.4-2.7 1.4-1.5 0-2.8-.6-2.8-1.4"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				clipPath: "url(#c)",
				children: /* @__PURE__ */ _jsx("path", {
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					d: "M13.8 9.4c0 1-1.5 1.7-3.3 1.7-1.8 0-3.3-.8-3.3-1.7m6.6 0c0-1-1.5-1.7-3.3-1.7-1.8 0-3.3.8-3.3 1.7m6.6 0v4.5c0 1-1.5 1.7-3.3 1.7-1.8 0-3.3-.8-3.3-1.7V9.4m6.6 0v1.5M7.2 9.4v1.5m6.6 0v1.5c0 1-1.5 1.7-3.3 1.7-1.8 0-3.3-.8-3.3-1.7V11m6.6 0c0 1-1.5 1.7-3.3 1.7-1.8 0-3.3-.8-3.3-1.7"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				clipPath: "url(#d)",
				children: /* @__PURE__ */ _jsx("path", {
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					d: "M22.2 8.2c0 1-1.7 2-3.9 2-2.1 0-3.8-1-3.8-2m7.7 0c0-1-1.7-2-3.9-2-2.1 0-3.8 1-3.8 2m7.7 0v5.3c0 1-1.7 2-3.9 2-2.1 0-3.8-1-3.8-2V8.2m7.7 0V10m-7.7-1.8V10m7.7 0v1.7c0 1.1-1.7 2-3.9 2-2.1 0-3.8-.9-3.8-2V10m7.7 0c0 1-1.7 2-3.9 2-2.1 0-3.8-1-3.8-2"
				})
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsx("clipPath", {
			id: "a",
			children: /* @__PURE__ */ _jsx("path", { d: "M0 0h24v24H0z" })
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "b",
			children: /* @__PURE__ */ _jsx("path", { d: "M0 8.6h7.9v7.9H0z" })
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "c",
			children: /* @__PURE__ */ _jsx("path", { d: "M5.6 6.8h9.7v9.7H5.6z" })
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "d",
			children: /* @__PURE__ */ _jsx("path", { d: "M12.7 5.2H24v11.3H12.7z" })
		})
	] })]
});
export default SvgSolutionBetSizes;
